import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import URI from 'urijs'
import { peUrlParams } from '../../entry/util/peUrlParams'
import destroySession from './destroy_session'

const LOGOUT_PARAM = 'forceLogout'

// Storing this in page memory so it'll be wiped out on reload or navigation
let dispatchAuthTokenThunk = false

/**
 * CAREFUL! Here be dragons
 *
 * This is used to work around a security issue with out-of-band auth
 * Issue details: https://hackerone.com/reports/1318328
 * Further notes in the commit message that added this (not to exposed in code comments)
 *
 * @param {*} dispatched Dispatched thunk promise from `profileSlice.authWithToken`
 */
export function markTokenLoginDispatch (dispatched) {
  dispatchAuthTokenThunk = dispatched
}

/**
 * Checks URL params for force logout flag and automatically logs you out if so
 */
export default async function forceLogoutWhenParamExists (state) {
  const params = peUrlParams()

  // Always remove this param immediately, otherwise SSO redirects may autologout again
  if (params.has(LOGOUT_PARAM)) {
    const uri = URI(window.location.href)
    window.history.replaceState('', '', uri.removeSearch(LOGOUT_PARAM).toString())
  }

  // Short circuit if not actually logged in
  if (!profileSlice.selectIsLoggedIn(store.getState())) {
    return false
  }

  // Don't logout **only if** we logged them in with a token _in this page view_ (SSO flow)
  if (dispatchAuthTokenThunk) {
    const resultType = (await dispatchAuthTokenThunk)?.type
    if (resultType === 'profile/authWithToken/fulfilled') {
      return false
    }
  }

  // Note: _almost_ always forcing logout due to https://hackerone.com/reports/1318328
  await destroySession()
  return true
}
